import React from "react";
import { appConfig } from '../../config';
import styles from "./Footer.module.scss";
import { GAevent } from "../../utils/googleAnalyticsHelper";

const Footer = () => {
  const { tnc, pp } = appConfig

  const supportsVR = "getVRDisplays" in navigator;

  return (
    <span className={styles.footer} style={{ marginRight: supportsVR && '60px' }}>
      <a href={tnc} className={styles.footerLinks} target="_blank" rel="noreferrer" onClick={() => GAevent('Guest-User', 'click', 'Terms of Use Button')}>
        Terms of Use
      </a>
      <a href={pp} className={styles.footerLinks} target="_blank" rel="noreferrer" onClick={() => GAevent('Guest-User', 'click', 'Privacy Policy Button')}>
        Privacy Policy
      </a>
    </span>
  );
};

export { Footer };
